import React from "react";
import { defaultFormValues, schema } from "./constants";
import { DuplicateProductFormValues } from "./types";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";

export interface DuplicateProductFormProviderProps {
  defaultValues?: Partial<DuplicateProductFormValues>;
  children?: React.ReactNode;
}

export const DuplicateProductFormProvider = ({
  defaultValues,
  children,
}: DuplicateProductFormProviderProps) => {
  const normalizedDefaultValues: Partial<DuplicateProductFormValues> =
    React.useMemo(() => {
      return {
        ...defaultFormValues,
        ...defaultValues,
      };
    }, []);

  const methods = useForm<DuplicateProductFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizedDefaultValues,
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
